import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { MarkdownModule } from 'ngx-markdown';
import { ChangelogRoutingModule } from './routing';
import { ChangelogComponent } from './changelog/changelog.component';

@NgModule({
  declarations: [ChangelogComponent],
  imports: [
    CommonModule,
    AuxiliaresModule,
    ChangelogRoutingModule,
    MarkdownModule.forChild(),
  ],
})
export class ChangelogModule {}
